import { jsx as _jsx } from "react/jsx-runtime";
import * as classNames from 'classnames';
import * as React from 'react';
import * as style from './Icon.styl';
import '../../../../public/styles/abacons.styl';
export class Icon extends React.Component {
    constructor(props) {
        super(props);
        this.getTooltipProps = () => {
            const { tooltipText, tooltipDirection } = this.props;
            const tooltipProps = {};
            if (tooltipText) {
                tooltipProps['data-rh'] = tooltipText;
            }
            if (tooltipDirection) {
                tooltipProps['data-rh-at'] = tooltipDirection;
            }
            return tooltipProps;
        };
    }
    render() {
        const { small, large, type } = this.props;
        const cssClasses = classNames(style.global, 'icon', 'icon-' + this.props.name, { small, large, [`icon-${type}`]: Boolean(type) }, classNames(this.props.customClasses));
        return _jsx("span", Object.assign({ className: cssClasses }, this.getTooltipProps()));
    }
}
